import * as React from 'react';
import { FavouriteDefinition } from 'app/types-shared';
import { useLoadPage, usePagination } from 'app/area/case-report/bowtie-listing/hooks';
import { useEffect } from 'react';
import './bowtie-listing.scss';
import { useTranslation } from 'app/infrastructure/translate/hooks';
import { caseListingTranslation } from 'app/area/case-report/case-listing/constants';
import { STATE } from 'app/constants';
import { useSelectors } from 'app/area/case-report/case-listing/hooks';
import { useCaseListingException } from 'app/area/case-report/components/use-case-listing-exception';
import { BowtieListingResultList } from 'app/area/case-report/bowtie-listing/components/bowtie-listing-result-list';

interface BowtieListingProps {
  workingDefinition: FavouriteDefinition;
  maxOptionsPerPage?: number;
  minimumOptionsNeededBeforePagination?: number;
  autoExecute: boolean;
}

export const BowtieListing = ({
  workingDefinition,
  maxOptionsPerPage = 1,
  minimumOptionsNeededBeforePagination = 1,
  autoExecute
}: BowtieListingProps) => {

  const translation = useTranslation(STATE.caseListing, caseListingTranslation);

  const {
    fetching,
    results,
    totalNumberOfResults,
    errorsExecuteFailed
  } = useSelectors();

  const {
    loadPage
  } = useLoadPage(
    workingDefinition
  );

  const {
    numberOfPages,
    shouldPaginate,
    currentPage,
    first,
    previous,
    next,
    last
  } = usePagination(totalNumberOfResults, maxOptionsPerPage, minimumOptionsNeededBeforePagination);

  useEffect(() => {
    autoExecute && loadPage(currentPage, maxOptionsPerPage);
  }, [currentPage, maxOptionsPerPage, autoExecute, loadPage]);

  const ErrorHandlingComponent = useCaseListingException({
    autoExecute,
    errorsExecuteFailed,
    fetching,
    totalNumberOfResults,
    translation
  });

  if (ErrorHandlingComponent !== null) {
    return ErrorHandlingComponent;
  }
  return <BowtieListingResultList
    translation={translation}
    results={results}
    fetching={fetching}
    workingDefinition={workingDefinition}
    maxOptionsPerPage={maxOptionsPerPage}
    numberOfPages={numberOfPages}
    shouldPaginate={shouldPaginate}
    currentPage={currentPage}
    first={first}
    previous={previous}
    next={next}
    last={last}
  />;
};
